/* eslint-disable react/jsx-key */
/* eslint-disable import/no-unresolved */
import { useAutocomplete } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import {
  AppBar,
  Button,
  Container,
  DialogContent,
  IconButton,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material'
import { autocompleteClasses } from '@mui/material/Autocomplete'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import { styled } from '@mui/material/styles'
import { DataGrid } from 'Components/LifeDataGrid'

import CustomButton from 'Components/CustomButton/CustomButton'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { makePostRequest } from 'utils/api'
import { currentDate } from 'utils/helpers'
import ModifierCreateForm from '../EditContact'
import ViewContact from '../ViewContact'
import { makeGetRequest } from 'utils/api'

const Root = styled('div')(
  ({ theme }) => `
  color: ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,.85)'};
  font-size: 14px;
`,
)

const Label = styled('label')`
  padding: 0 0 4px;
  line-height: 1.5;
  display: block;
`

const InputWrapper = styled('div')(
  ({ theme }) => `
  width: 300px;
  border: 1px solid ${theme.palette.mode === 'dark' ? '#434343' : '#d9d9d9'};
  background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
  border-radius: 4px;
  padding: 1px;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    border-color: ${theme.palette.mode === 'dark' ? '#177ddc' : '#40a9ff'};
  }

  &.focused {
    border-color: ${theme.palette.mode === 'dark' ? '#177ddc' : '#40a9ff'};
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  & input {
    background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
    color: ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,.85)'};
    height: 30px;
    box-sizing: border-box;
    padding: 4px 6px;
    width: 0;
    min-width: 30px;
    flex-grow: 1;
    border: 0;
    margin: 0;
    outline: 0;
  }
`,
)

function Tag(props) {
  const { label, onDelete, ...other } = props
  return (
    <div {...other}>
      <span>{label}</span>
      <CloseIcon onClick={onDelete} />
    </div>
  )
}

Tag.propTypes = {
  label: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
}

const StyledTag = styled(Tag)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  height: 24px;
  margin: 2px;
  line-height: 22px;
  background-color: ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : '#fafafa'};
  border: 1px solid ${theme.palette.mode === 'dark' ? '#303030' : '#e8e8e8'};
  border-radius: 2px;
  box-sizing: content-box;
  padding: 0 4px 0 10px;
  outline: 0;
  overflow: hidden;

  &:focus {
    border-color: ${theme.palette.mode === 'dark' ? '#177ddc' : '#40a9ff'};
    background-color: ${theme.palette.mode === 'dark' ? '#003b57' : '#e6f7ff'};
  }

  & span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & svg {
    font-size: 12px;
    cursor: pointer;
    padding: 4px;
  }
`,
)

const Listbox = styled('ul')(
  ({ theme }) => `
  width: 300px;
  margin: 2px 0 0;
  padding: 0;
  position: absolute;
  list-style: none;
  background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
  overflow: auto;
  max-height: 250px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;

  & li {
    padding: 5px 12px;
    display: flex;

    & span {
      flex-grow: 1;
    }

    & svg {
      color: transparent;
    }
  }

  & li[aria-selected='true'] {
    background-color: ${theme.palette.mode === 'dark' ? '#2b2b2b' : '#fafafa'};
    font-weight: 600;

    & svg {
      color: #1890ff;
    }
  }

  & li.${autocompleteClasses.focused} {
    background-color: ${theme.palette.mode === 'dark' ? '#003b57' : '#e6f7ff'};
    cursor: pointer;

    & svg {
      color: currentColor;
    }
  }
`,
)
const ITEM_HEIGHT = 50
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 350,
    },
  },
}
const Titres = [
  { id: 1, label: 'Mme' },
  { id: 2, label: 'Mr' },
  { id: 3, label: 'Mlle' },
  { id: 4, label: 'Dr' },
  { id: 5, label: 'ST' },
]

export default function EditContactGroup({ id, groupName = '', setContactGroupOpen }) {
  const [open, setOpen] = useState(true)
  const [openCreer, setOpenCreer] = useState(false)
  const [rowsContacts, setRowsContacts] = useState([])
  const [rows, setRows] = useState(100)
  const [page, setPage] = useState(0)
  const [selectedRows, setSelectedRows] = useState([])
  const [contacts, setContacts] = useState([])
  const [userId, setID] = useState('')
  const getContacts = async () => {
    const response = await makeGetRequest('/api/Social/get-empty-contact-groups/', {}, true)
    setContacts(response.data)
  }

  const dgrid = useRef()
  const [openContact, setOpenContact] = React.useState(false)
  const [user, setUser] = React.useState({})
  const [isGetUser, setGetUser] = React.useState(false)

  React.useEffect(() => {
    const getUserData = async () => {
      const getUser = await makeGetRequest(`/api/Social/get-contact/${userId}`, {}, true)
      setUser(getUser.data[0])
    }
    if (isGetUser) {
      getUserData()
    }
  }, [isGetUser])
  useEffect(() => {
    fetchContacts()
  }, [id])
  function handleClickOpenContact() {
    setOpenContact(true)
    setGetUser(true)
  }

  function handleCloseContact() {
    setOpenContact(false)
  }
  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl,
  } = useAutocomplete({
    id: 'customized-hook-demo',
    multiple: true,
    options: contacts,
    getOptionLabel: (option) => `${option.NomPreNom}`,
  })

  const fetchContacts = async (pagination = '') => {
    let url = '/api/Social/get-contact-on-group/'
    if (pagination !== '') {
      //general=true&
      url += pagination
    }
    const data = await makeGetRequest(`${url}${id}`, {}, true)
    setRows(data.data.length)
    setRowsContacts(data.data)
  }
  const handleClickOpen = () => {
    setOpen(true)
    getContacts()
    fetchContacts()
  }
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchContacts(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchContacts(url)
  }
  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert('Sélectionner une contacts ')
    } else {
      const response = await makePostRequest(
        '/api/Social/remove-group-from-contact/',
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
      }
    }
    fetchContacts()
  }
  const handleCloseGroupesAdd = () => {
    const url = '/api/Social/add-group-to-contact/'
    const selected = value.map((v) => v.id)
    const { data } = makePostRequest(url, { Group: id, selected: selected }, {}, true)
    setOpenCreer(false)
    fetchContacts()
  }
  const handleClose = () => {
    // setOpen(false)
    // setOpenCreer(false)
    setContactGroupOpen(false)
  }
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Date: currentDate(),
    },
  })

  const columns = [
    {
      field: 'Titre',
      headerName: 'Titre',
      width: 150,
      editable: false,
      valueGetter: (params) =>
        `${
          params.row.Titre !== undefined || params.row.Titre.length !== 0
            ? Titres[params.row.Titre - 1]?.label
            : 'N/A'
        }`,
    },
    {
      field: 'Nom',
      headerName: 'Nom',
      width: 400,
      editable: false,
    },
    {
      field: 'Prenom',
      headerName: 'Prenom',
      width: 400,
      editable: false,
    },
    {
      field: 'lien',
      headerName: 'Lien',

      width: 90,
      editable: false,
      renderCell: (params) => {
        return <ViewContact viewLink={true} id={params.id} setModalOpen={(e) => {}} />
      },
    },
  ]

  return (
    <>
      {/* <Button onClick={handleClickOpen}>List of contacts</Button> */}
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            backgroundColor: 'rgba(0, 27, 66, 0.9)',
            color: '#fff',
          },
        }}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar style={{ color: '#fff', backgroundColor: 'black' }}>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {groupName || 'Selected Group'}
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <Container
            maxWidth="lg"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
            }}
          >
            <div
              style={{
                marginLeft: '80%',
                paddingBottom: '10px',
              }}
            >
              <CustomButton
                onClick={() => {
                  setOpenCreer(true)
                }}
              >
                Créer
              </CustomButton>
              <Dialog
                PaperProps={{
                  sx: {
                    height: '50%',
                  },
                }}
                disableEscapeKeyDown
                open={openCreer}
                onClose={() => setOpenCreer(false)}
              >
                <DialogTitle sx={{ color: 'black !important' }}>
                  Add all contacts to selected group
                </DialogTitle>
                <DialogContent>
                  <Root>
                    <div {...getRootProps()}>
                      <Label {...getInputLabelProps()}>Select Empty contacts</Label>
                      <InputWrapper ref={setAnchorEl} className={focused ? 'focused' : ''}>
                        {value.map((option, index) => (
                          <StyledTag label={option.NomPreNom} {...getTagProps({ index })} />
                        ))}

                        <input {...getInputProps()} />
                      </InputWrapper>
                    </div>
                    {groupedOptions.length > 0 ? (
                      <Listbox {...getListboxProps()}>
                        {groupedOptions.map((option, index) => (
                          <li {...getOptionProps({ option, index })}>
                            <span key={option.index}>{option.NomPreNom}</span>
                            <CheckIcon fontSize="small" />
                          </li>
                        ))}
                      </Listbox>
                    ) : null}
                  </Root>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseGroupesAdd}>Ok</Button>
                  <Button
                    onClick={() => {
                      setOpenCreer(false)
                    }}
                  >
                    Cancel
                  </Button>
                </DialogActions>
              </Dialog>
              <ModifierCreateForm ID={selectedRows.length === 0 ? 0 : selectedRows[0]} />
              <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
            </div>
            <div
              style={{
                height: 750,
                width: '100% ',
                color: 'black',
                background: 'white',
                borderRadius: '5px',
              }}
            >
              <DataGrid
                ref={dgrid}
                rows={rowsContacts}
                // onRowClick={(params, event) => {
                //   handleClickOpenContact()
                //   setID(params.id)
                // }}
                onCellClick={(params, event) => {
                  event.defaultMuiPrevented = true
                }}
                columns={columns}
                pageSize={rows !== undefined ? rows.length : 0}
                rowCount={rows !== undefined ? rows.length : 0}
                onPageSizeChange={handleRowsChange}
                onPageChange={handlePageChange}
                rowsPerPageOptions={[10, 20, 40, 80, 100]}
                pagination
                onSelectionModelChange={(itm) => setSelectedRows([...itm])}
                paginationMode="server"
                disableSelectionOnClick
                components={{
                  NoRowsOverlay: () => (
                    <Stack height="100%" alignItems="center" justifyContent="center">
                      Aucune donnée trouvée
                    </Stack>
                  ),
                  NoResultsOverlay: () => (
                    <Stack height="100%" alignItems="center" justifyContent="center">
                      Aucune donnée trouvée
                    </Stack>
                  ),
                }}
                checkboxSelection
              />
            </div>
          </Container>
        </DialogContent>
      </Dialog>
    </>
  )
}
